import axios from 'axios';
import { LOCAL_STORAGE_ACCESS_TOKEN } from '@/helpers/local_storage_constants';
import { interceptorResponse, interceptorError } from '@/helpers/interceptorResponse';

const api = axios.create({
    baseURL: `${process.env.VUE_APP_API_CAS_BASE}`,
    headers: {
        "Content-Type": "Application/json"
    }
});

const authInterceptor = (config) => {
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN);
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
};

api.interceptors.request.use(authInterceptor);

api.interceptors.response.use(
    interceptorResponse,
    (error) => {
        return interceptorError(error, '/error');
    }
);

export default api;